import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-5" data-id="element-74" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-2xl border border-brand-line bg-brand-light p-4 shadow-sm" data-id="element-75" data-mp="1o33uyj8shwit">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-76" data-mp="22125tenwjatk" />
        <div data-id="element-77" data-mp="1x28vfv3wvzxm">
          <h2 className="mb-1 font-display text-base font-extrabold uppercase leading-tight sm:text-xl" data-id="element-78" data-mp="19eqxfhu205m7">
            Your Investment Is 100% Protected
          </h2>
          <p className="text-sm font-normal leading-snug text-brand-muted sm:text-base" data-id="element-79" data-mp="14hh9y7q86410">
            Take seven full days to explore every module, review the lessons, study the installation
            systems, and use the templates. If you decide the program isn't right for you, simply
            contact us within the first 7 days and we'll refund 100% of your purchase. No questions
            asked.
          </p>
        </div>
      </div>
    </section>;
}